import { isRecord } from '@change-corgi/core/types';

import { REDACTED } from './constants';

const SENSITIVE_SIGNATURE_FIELDS: readonly string[] = [
	'firstName',
	'lastName',
	'email',
	'address',
	'city',
	'stateCode',
	'countryCode',
	'postalCode',
	'phoneNumber',
	'reasonForSigning',
	'recaptchaResponse',
	'userId',
];

export function redactSensitiveSignatureData(signatureData: unknown): unknown {
	if (!isRecord(signatureData)) return signatureData;

	const shallowClone = { ...signatureData };

	for (const key of SENSITIVE_SIGNATURE_FIELDS) {
		if (key in shallowClone && shallowClone[key] && typeof shallowClone[key] === 'string') {
			shallowClone[key] = REDACTED;
		}
	}

	return shallowClone;
}
